import { Link, Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import { CarrotPlanMediaItem } from "types/CarrotPlanOptions"
import { CarrotPlanFormOption, MenuItemOptionFields } from "./hooks/useCarrotPlanMappings"
import React, { Dispatch, ReactElement, SetStateAction } from "react"
import { AddItemToPlanParams, Recommendation } from "./AdditionalRecommendations"

type RecommendationDisplayProps = {
  label: string
  menuItem: CarrotPlanFormOption<MenuItemOptionFields>
  mediaItem?: CarrotPlanMediaItem
  updateRecommendedItems:
    | Dispatch<SetStateAction<CarrotPlanFormOption<MenuItemOptionFields>[]>>
    | Dispatch<SetStateAction<CarrotPlanMediaItem[]>>
  addItemToPlan: ({ menuItem, updateRecommendedItems, mediaItem }: AddItemToPlanParams) => void
  dismissItem: ({ menuItem, updateRecommendedItems, mediaItem }: AddItemToPlanParams) => void
}

function RecommendationDisplay({
  label,
  menuItem,
  updateRecommendedItems,
  addItemToPlan,
  dismissItem,
  mediaItem
}: RecommendationDisplayProps): ReactElement {
  const theme = useTheme()

  return (
    <Stack spacing={theme.spacing(theme.tokens.spacing.xs)}>
      <Stack direction="row" justifyContent="flex-end"></Stack>
      <Typography variant="body1">{label}</Typography>
      <Stack direction="row" spacing={theme.spacing(theme.tokens.spacing.md)} justifyContent="flex-end">
        <Link
          component="button"
          onClick={(e) => {
            e.preventDefault()
            addItemToPlan({ menuItem, mediaItem, updateRecommendedItems })
          }}
        >
          Add to plan
        </Link>
        <Link
          component="button"
          onClick={(e) => {
            e.preventDefault()
            dismissItem({ menuItem, mediaItem, updateRecommendedItems })
          }}
        >
          Dismiss
        </Link>
      </Stack>
    </Stack>
  )
}

export function RecommendationDisplaySection({
  recommendations,
  typeLabel,
  addItemToPlan,
  dismissItem
}: {
  recommendations: Recommendation[]
  typeLabel: string
  addItemToPlan: ({ menuItem, updateRecommendedItems, mediaItem }: AddItemToPlanParams) => void
  dismissItem: ({ menuItem, updateRecommendedItems, mediaItem }: AddItemToPlanParams) => void
}): ReactElement {
  const theme = useTheme()

  return recommendations.length ? (
    <Stack spacing={theme.spacing(theme.tokens.spacing.xs)}>
      <Typography variant="body1" fontWeight="bold">
        {typeLabel}
      </Typography>
      <Stack spacing={theme.spacing(theme.tokens.spacing.sm)}>
        {recommendations.map((recommendation, index) => (
          <RecommendationDisplay
            key={index}
            label={recommendation.label}
            updateRecommendedItems={recommendation.updateRecommendedItems}
            menuItem={recommendation.menuItem}
            mediaItem={recommendation.contentItem ? recommendation.contentItem : null}
            addItemToPlan={addItemToPlan}
            dismissItem={dismissItem}
          />
        ))}
      </Stack>
    </Stack>
  ) : null
}
